export default __webpack_public_path__ + "static/media/Emojis08.6870029b.png";